const HOUSEHOLD_DETAILS = 'Household Details'
const FINANCIAL_HEALTH = 'Financial Health'
const POST_REQUEST_APPROVED = 'Post Request Approved'
const POST_REQUEST_APPROVED_THREE_MONTHS = 'Post Request Approved Three Months'
const POST_REQUEST_APPROVED_SIX_MONTHS = 'Post Request Approved Six Months'
const POST_REQUEST_DECLINED = 'Post Request Declined'
const POST_REQUEST_DECLINED_THREE_MONTHS = 'Post Request Declined Three Months'
const POST_REQUEST_DECLINED_SIX_MONTHS = 'Post Request Declined Six Months'
const POST_CONTRIBUTION_ABSOLUTE = 'Post Contribution Absolute'
const POST_CONTRIBUTION_NET = 'Post Contribution Offset'

const SURVEY_NAMES = [
  HOUSEHOLD_DETAILS,
  FINANCIAL_HEALTH,
  POST_REQUEST_APPROVED,
  POST_REQUEST_APPROVED_THREE_MONTHS,
  POST_REQUEST_APPROVED_SIX_MONTHS,
  POST_REQUEST_DECLINED,
  POST_REQUEST_DECLINED_THREE_MONTHS,
  POST_REQUEST_DECLINED_SIX_MONTHS,
  POST_CONTRIBUTION_NET,
  POST_CONTRIBUTION_ABSOLUTE,
]

export default {
  HOUSEHOLD_DETAILS,
  FINANCIAL_HEALTH,
  POST_REQUEST_APPROVED,
  POST_REQUEST_APPROVED_THREE_MONTHS,
  POST_REQUEST_APPROVED_SIX_MONTHS,
  POST_REQUEST_DECLINED,
  POST_REQUEST_DECLINED_THREE_MONTHS,
  POST_REQUEST_DECLINED_SIX_MONTHS,
  POST_CONTRIBUTION_NET,
  POST_CONTRIBUTION_ABSOLUTE,
  SURVEY_NAMES,
}
